const tableIndexStore = {
  state: {
    tableIndex: 0,
  },
  getters: {
    tableIndex(state) {
      return state.tableIndex;
    },
  },
  mutations: {
    UPDATE_TABLE(state, payload) {
      state.tableIndex = payload;
    },
  },
};

export default tableIndexStore;
